module.exports = __webpack_public_path__ + "static/media/uttarakhand.b2d599d1.png";